import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { isCustomResumeDomain } from "./utils/functions";

const root = ReactDOM.createRoot(document.getElementById("root"));
isCustomResumeDomain();

// Google One Tap / GIS — Web OAuth client for project careerclawnew.
// Client secret stays in Firebase Console → Authentication → Google only.
const clientId = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID;

root.render(
  // <React.StrictMode>
  <GoogleOAuthProvider clientId={clientId}>
    <App />
  </GoogleOAuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
